export default __webpack_public_path__ + "static/media/MMP Face Logo 2.a3da1839.svg";